const ClinicalHeaderBar = () => {
  return (
    <div className="bg-muted/50 border-b border-border py-2 px-4 text-center">
      <p className="text-xs md:text-sm text-muted-foreground">
        <span className="font-medium">Recurso Científico sobre PPP e Glândulas de Tyson</span>
        <span className="mx-2 hidden sm:inline">|</span>
        <br className="sm:hidden" />
        <span>Revisado em 15 de janeiro de 2026</span>
        <span className="mx-2 hidden sm:inline">|</span>
        <br className="sm:hidden" />
        <span>Baseado em Padrões Dermatológicos</span>
      </p>
    </div>
  );
};

export default ClinicalHeaderBar;
